const rootTaskDeliverablesPathLabel = 'Deliverables';

export default rootTaskDeliverablesPathLabel;
